import { useState, useEffect } from "react";

const CountdownTimer = ({ initialSeconds, onFinish=()=> {} }) => {
  const [seconds, setSeconds] = useState(initialSeconds);

  useEffect(() => {
    if (seconds <= 0) return onFinish();    
    const interval = setInterval(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [seconds,initialSeconds]);

  const formatTime = (totalSeconds) => {
    const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
    const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
    const secs = String(Math.floor(totalSeconds % 60)).padStart(2, "0");
    return `${hours}:${minutes}:${secs}`;
  };

  return <span>{formatTime(seconds)}</span>;
};

export default CountdownTimer;
